import R from './domains';

/**
 * Gets the device type from the domain.
 *
 * @param  {String} domain - the domain of the URL
 * @return {String}
 */
function getDevice(domain) {
  return (R.quotesMobile.test(domain) || R.medicareMobile.test(domain))
    ? 'mobile'
    : 'desktop';
}

export default getDevice;
